/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CommentRectXIcon16Light } from './CommentRectXIcon16Light';
import { CommentRectXIcon16Regular } from './CommentRectXIcon16Regular';
import { CommentRectXIcon16Solid } from './CommentRectXIcon16Solid';
import { CommentRectXIcon20Light } from './CommentRectXIcon20Light';
import { CommentRectXIcon20Regular } from './CommentRectXIcon20Regular';
import { CommentRectXIcon20Solid } from './CommentRectXIcon20Solid';
import { CommentRectXIcon24Regular } from './CommentRectXIcon24Regular';
import { CommentRectXIcon24Solid } from './CommentRectXIcon24Solid';
import { CommentRectXIcon32Regular } from './CommentRectXIcon32Regular';
import { CommentRectXIcon64Regular } from './CommentRectXIcon64Regular';
var sizes = {
    16: {
        light: CommentRectXIcon16Light,
        regular: CommentRectXIcon16Regular,
        solid: CommentRectXIcon16Solid,
    },
    20: {
        light: CommentRectXIcon20Light,
        regular: CommentRectXIcon20Regular,
        solid: CommentRectXIcon20Solid,
    },
    24: {
        regular: CommentRectXIcon24Regular,
        solid: CommentRectXIcon24Solid,
    },
    32: {
        regular: CommentRectXIcon32Regular,
    },
    64: {
        regular: CommentRectXIcon64Regular,
    },
};
export var CommentRectXIcon = forwardRef('CommentRectXIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
